import { render } from "./SingleIllustration.vue?vue&type=template&id=c3a9a182"
import script from "./SingleIllustration.vue?vue&type=script&lang=js"
export * from "./SingleIllustration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__